import "core-js/modules/es6.object.freeze";
export var freeze = function freeze(obj) {
  return Object.freeze(obj);
};